import {
  DetailedHTMLProps,
  EmbedHTMLAttributes,
  useEffect,
  useState,
} from "react";

/*
TODO: If the KiCanvas API of the future has an npm library version, switch to that,
remove the source code in public/kicanvas/, and switch how we dynamically load
the script.
*/

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      "kicanvas-embed": DetailedHTMLProps<KiCanvasEmbedAttributes, HTMLElement>;
    }
  }
}

interface KiCanvasEmbedAttributes extends EmbedHTMLAttributes<HTMLElement> {
  controls?: string;
}

type KiCanvasProps = {
  schematic_path: string;
  controls?: string;
};

const KiCanvas = ({ schematic_path, controls = "basic" }: KiCanvasProps) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    // Don't load the script if it's already been loaded
    if (document.querySelector('script[src="/kicanvas/kicanvas.js"]')) {
      setScriptLoaded(true);
      return;
    }

    // Create and load the script
    const script = document.createElement("script");
    script.src = "/kicanvas/kicanvas.js";
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    script.onerror = (error) => {
      // eslint-disable-next-line no-console
      console.error("Error loading KiCanvas script:", error);
    };

    document.body.appendChild(script);
  }, []);

  return (
    <>
      {scriptLoaded ? (
        <kicanvas-embed src={schematic_path} controls={controls} />
      ) : (
        <div>Loading...</div>
      )}
    </>
  );
};

export default KiCanvas;
